/*
  <skigrin-before-after> — schuifbalk tussen twee afbeeldingen.

  Het range-input doet het echte werk: dat is onzichtbaar maar bedienbaar met
  muis, vinger én toetsenbord (pijltjes), zonder extra code voor touch events.
*/
class SkigrinBeforeAfter extends HTMLElement {
  connectedCallback() {
    this.range = this.querySelector('[data-ba-range]');
    this.frame = this.querySelector('[data-ba-frame]');
    if (!this.range || !this.frame) return;

    this.apply();
    this.range.addEventListener('input', () => this.apply());
  }

  apply() {
    this.frame.style.setProperty('--skigrin-ba-pos', `${this.range.value}%`);
    this.range.setAttribute('aria-valuetext', `${this.range.value}%`);
  }
}

if (!customElements.get('skigrin-before-after')) {
  customElements.define('skigrin-before-after', SkigrinBeforeAfter);
}
